module.exports = require('../../modules/_wks-ext').f('species');



//////////////////
// WEBPACK FOOTER
// ./~/core-js/library/fn/symbol/species.js
// module id = 596
// module chunks = 2